import React from "react";
import { useState } from "react";
import useDidMountEffect from "../../Common/UseDidMountEffect";
import DebouncedTextField from "../../Common/DebouncedTextField";

type Props = {
    initialValue?: string;
    onChange: (nextValue?: string) => void;
};

const ProductFilter = (props: Props) => {
    const [value, setValue] = useState(props.initialValue ?? "");

    useDidMountEffect(() => {
        props.onChange(value);
    }, [value]);

    const render = () => {
        return (
            <DebouncedTextField id="products-product-filter"
                initialValue={value}
                label="Filtrera produkter/evenemang"
                style={{ flex: 1, margin: '0 3px' }}
                onChange={(nextValue: string) => {
                    setValue(nextValue);
                }}
            />
        );
    };

    return render();
};

export default ProductFilter;
